var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDraw = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30.077,
  height: 32.988,
  fill: "currentColor",
  stroke: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 62",
  d: "m7.933 15.899-1.158 7.168s-.049.082 0 0 7.07-1.156 7.07-1.156L28.269 8.224s.035-.035.076-.082c.4-.449.75-.734.736-.988s-.551-.672-.551-.672L23.788 1.65s-.852-.7-.973-.66c-.517.127-14.882 14.909-14.882 14.909Z",
  fill: "current",
  stroke: "current",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 63",
  d: "M9.041 16.391c1.528 1.465 4.788 4.762 4.788 4.762l-4.512.648-1.113-.957Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 64",
  d: "M3.379 28.438a5.974 5.974 0 0 0-2.511 1.416c-.731.914-.885 1.668-.143 2.375s1.7.688 3.979 0 3.17-1.869 5.153-2.744a9.812 9.812 0 0 1 5.16-.561 9.058 9.058 0 0 1 5.927 3.723",
  fill: "none",
  stroke: "current",
  strokeLinecap: "round",
  strokeWidth: 0.5
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 66",
  d: "M10.031 14.992 23.225 1.2",
  fill: "none",
  stroke: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 67",
  d: "M12.602 17.56 25.796 3.768",
  fill: "none",
  stroke: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 68",
  d: "M15.171 20.129 28.365 6.337",
  fill: "none",
  stroke: "#fff"
})));
export default SvgDraw;